import React from 'react';
import * as S from './ImageThumbnail.styles';

interface ImageThumbnailProps {
  src: string;
  alt: string;
  isActive: boolean;
  onClick: () => void;
}

export default function ImageThumbnail({
  src,
  alt,
  isActive,
  onClick,
}: ImageThumbnailProps) {
  return (
    <S.Wrapper isActive={isActive} onClick={onClick}>
      <S.Image src={src} alt={alt} loading="lazy" />
    </S.Wrapper>
  );
}